import React from 'react'
import { Field } from 'react-final-form'
import PropTypes from 'prop-types'

import { pick } from '@styled-system/props'

import Utils from 'Utils'

import Select from './Select'

function SelectField({
  checkErrorIfDirty,
  displayError,
  input,
  name,
  ...rest
}) {
  return (
    <Field name={name}>
      {({ input: { value, onChange: handleChange }, meta }) => {
        const { error } = Utils.Form.hasError(meta, checkErrorIfDirty)

        return (
          <Select
            displayError={displayError}
            error={error}
            value={value}
            {...input}
            {...pick(rest)}
            {...rest}
            onChange={handleChange}
          />
        )
      }}
    </Field>
  )
}

SelectField.defaultProps = {
  checkErrorIfDirty: false,
  displayError: true,
  input: null,
}

SelectField.propTypes = {
  checkErrorIfDirty: PropTypes.bool,
  displayError: PropTypes.bool,
  input: PropTypes.object,
  name: PropTypes.string.isRequired,
}

export default SelectField
